import React from 'react' // eslint-disable-line

import styled from 'styled-components'
export const WordpressContent = styled.div`
  width: 100%;
  min-height: 350px;
  /* Overrides cms.saatchiart.com styles */
  .entry-content {
    margin: 0;
  }
  .entry-title {
    display: none;
  }
`